<template>
  <AuthPage :page="$page" type="options" />
</template>

<script>
import { AuthPage } from '@/components/templates'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'AuthOptions',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_auth_options',
  components: { AuthPage },
}
</script>
